<template>
  <div class="index">
    <div class="time">
      {{ timeoutStr }}
    </div>
    <div class="top-box">
      <img style="width: 200px;height: 35px;" src="@/assets/images/mxn/send.png" alt="">
      <div class="amount">
        <div class="tip">monto & pagar</div>
        <div class="number">{{ order.amount.toFixed(2) }}</div>
      </div>
    </div>
    <div class="main">
      <!-- 转账信息 -->
      <div class="top">
        <div class="time-out" v-show="!showOrder">
          {{ tip }}
        </div>
        <div class="order" v-show="showOrder">
          <div class="head">Transferencia</div>
          <div class="card">
            <div>
              <span>Banco：</span>
              <b v-clipboard:copy="order.transferBank"
                 v-clipboard:success="firstCopySuccess"
                 v-clipboard:error="firstCopyError">{{ order.transferBank }}
                <img src="@/assets/images/copy@3x.png" alt="Copy">
              </b>
            </div>
            <div>
              <span>Beneficiario：</span>
              <b v-clipboard:copy="order.accountName"
                 v-clipboard:success="firstCopySuccess"
                 v-clipboard:error="firstCopyError">{{ order.accountName }}
                <img src="@/assets/images/copy@3x.png" alt="Copy">
              </b>
            </div>
            <div>
              <span>Importe del pago：</span>
              <b v-clipboard:copy="order.amount.toFixed(2).toString()"
                 v-clipboard:success="firstCopySuccess"
                 v-clipboard:error="firstCopyError">{{ order.amount.toFixed(2) }}
                <img src="@/assets/images/copy@3x.png" alt="Copy">
              </b>
            </div>
            <div>
              <span>CLABE：</span>
              <b v-clipboard:copy="order.accountNumber"
                 v-clipboard:success="firstCopySuccess"
                 v-clipboard:error="firstCopyError">{{ order.accountNumber }}
                <img src="@/assets/images/copy@3x.png" alt="Copy">
              </b>
            </div>
          </div>
        </div>
      </div>
      <!-- 步骤提示 -->
      <div class="step">
        <img style="width: 0.75rem;height: 0.75rem;" src="@/assets/images/mxn/image-step.png" alt="">
        <div class="text">
          <div>Paso 1:</div>
          <div>Copia la CLABE</div>
        </div>
      </div>
      <div class="step">
        <img style="width: 0.75rem;height: 0.75rem;" src="@/assets/images/mxn/image-step.png" alt="">
        <div class="text">
          <div>Paso 2:</div>
          <div>Ingrese a tu aplicación del banco, pega la CLABE, ingrese el monto de recarga y paga.</div>
        </div>
      </div>


      <div class="bottom-tips"
           v-if="order.logoEmail"
           v-clipboard:copy="order.logoEmail || ' '"
           v-clipboard:success="firstCopySuccess"
           v-clipboard:error="firstCopyError"
      >
        If you have any questions, connect us by email:
        <span>
            <span style="vertical-align: middle;color:  #192252">{{ order.logoEmail }}</span>
            <img style="width: 0.25rem; height: 0.25rem;vertical-align: middle;" src="@/assets/images/copy@3x.png"
                 alt="Copy">
          </span>
      </div>
    </div>
    <success ref="success"></success>
    <fail ref="fail"></fail>
  </div>
</template>

<script>
import fail from "@/pages/mxn/fail.vue";
import success from "@/pages/mxn/success.vue";

export default {
  components: {success, fail},
  data() {
    return {
      no: null,
      showOrder: false,
      order: {
        amount: 0.00
      },
      timeoutStr: '00:00',
      tip: 'El pedido no existe'  //  El pedido se ha agotado 失效
    }
  },
  mounted() {
    this.Params = this.$route.query
    // 检查no参数是否为空
    if (this.Params.no) {
      this.no = this.Params.no
      this.payment()
      // 每2秒请求一次
      this.timer = setInterval(this.payment, 2000)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.no = null
  },
  methods: {
    payment() {
      this.axios.get(`/api/order/orderStatus/${this.no}`).then(res => {
          if (!res.data.code == 0) {
            clearTimeout(this.timer)
            return;
          }
          this.order = res.data.data
          if (res.data.data.status == 0) {
            if (res.data.data.timeoutSeconds <= 0) {
              this.order.amount = 0
              this.showOrder = false
              this.tip = 'El pedido se ha agotado'
              this.timeoutStr = '00:00'
              clearTimeout(this.timer)
              return;
            }
            this.showOrder = true
            this.timeoutStr = res.data.data.timeoutStr
          } else if (res.data.data.status == 1) {
            this.showOrder = true
            clearTimeout(this.timer)
            this.$refs.success.openDialog(res.data.data.callbackUrl)
          } else if (res.data.data.status == 2) {
            this.showOrder = true
            clearTimeout(this.timer)
            this.$refs.fail.openDialog(res.data.data.callbackUrl)
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },
    firstCopySuccess(e) {
      this.$toast("copied successfully")
    },
    firstCopyError(e) {
      this.$toast("copied fail")
    },
  }
}
</script>

<style lang="scss" scoped>
.index {
  background-image: linear-gradient(137.64deg, #6378f0, #283bb2 70.1%);
  font-family: arial;
  font-size: 16px;
  height: 100vh;
  color: #ffffff;
  text-align: left;
  position: relative;
}

.time {
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  top: 40px;
  right: 25px;
}

.top-box {
  background-image: url('../../assets/images/mxn/top-box.png');
  background-repeat: no-repeat;
  background-size: 80% 100%;
  height: 15vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.top-box .amount {
  font-weight: bold;
}

.top-box .amount .number {
  font-size: .65rem;
}

.main {
  background-color: #FFFFFF;
  border-radius: 0.5rem 0.5rem 0 0;
  height: calc(100% - 15vh);
  width: 100vw;
  color: #333;
}

.top {
  padding: 0.4rem;
}

.top .time-out {
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  line-height: 60px;
}

.top .head {
  color: #192252;
}

.top .card {
  background: linear-gradient(180deg, #000 1.39%, #2c313e 99.82%);
  border-radius: 12px;
  margin: 0.2rem 0;
  padding: 0.22rem;
  text-align: left;
}

.top .card div span {
  font-size: .32rem;
  font-weight: 800;
  color: #66b1ff;
}

.top .card div b {
  font-size: .26rem;
  font-weight: 800;
  color: #FFFFFF;
}

.top .card div b img {
  width: 0.26rem;
  height: 0.26rem;
  vertical-align: middle;
  margin-left: 2px;
}

.top .card div:nth-child(n+2):nth-child(-n+4) {
  /* 添加样式到第2到第4个div */
  margin-top: .28rem;
}


.step {
  display: flex;
  border-radius: 16px;
  align-items: center;
  background-color: #e8eeff;
  padding: 0.2rem 0.32rem;
  margin: 10px 0.4rem;

  img {
    margin-right: 0.2rem;
  }

  .text {
    color: #192252;
    flex-direction: column;
  }
}

.bottom-tips {
  margin-top: 50px;
  text-align: center;
  font-size: 0.3rem;
  font-weight: bold;
  padding: 0.3rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/mxn/index.vue